const reasons = [
  { icon: 'ri-search-eye-line', title: 'Диагностика до обучения', desc: 'Сначала разбираемся в реальных задачах компании и участников, а не начинаем с готового шаблона.' },
  { icon: 'ri-file-list-3-line', title: 'Реальные кейсы', desc: 'Используем ситуации из практики участников, когда это возможно, а не абстрактные примеры.' },
  { icon: 'ri-tools-line', title: 'Практика', desc: 'Инструменты отрабатываются, а не просто обсуждаются — руководители применяют их на реальных ситуациях.' },
  { icon: 'ri-settings-3-line', title: 'Адаптация', desc: 'Программа корректируется под специфику бизнеса и уровень руководителей.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'После обучения при необходимости продолжается работа с реальными ситуациями руководителя.' },
  { icon: 'ri-file-copy-2-line', title: 'Систематизация', desc: 'При необходимости компания получает инструменты, алгоритмы, чек-листы и материалы для дальнейшего применения.' },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему обучение не заканчивается тренингом, а приводит к изменению управленческого поведения
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div key={r.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наша задача — не просто обучить руководителя инструментам, а помочь ему применять их в реальной работе.
          </p>
        </div>
      </div>
    </section>
  );
}